import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Box from '@mui/material/Box';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import { ToastContainer, toast } from 'react-toastify';


import '../modals.css';

const SwitchAccounts = ( { close, user, setViewing } ) => {
    const [ search, setSearch ] = useState( '' );
    const [ fullList, setFullList ] = useState( [] );
    const [ currList, setCurrList ] = useState( [] );
    const [ newView, setNewView ] = useState( [] );

    const filterGroup = ( e ) => {
        setSearch( e.target.value );
    };

    const prepSwitch = ( aid ) => {
        setCurrList( prev => prev.map( i => i.aid === aid ? { ...i, checked: !i.checked } : i ) );
        setFullList( prev => prev.map( i => i.aid === aid ? { ...i, checked: !i.checked } : i ) );
    }

    const applySwitch = () => {
        setViewing( newView );
        close();
    }

    const selectAll = () => {
        setFullList( prev => prev.map( i => { return { ...i, checked: true } } ) );
    }

    const deselectAll = () => {
        setFullList( prev => prev.map( i => { return { ...i, checked: false } } ) );
    }

    useEffect( () => {
        if ( user.additionalAccounts && user.additionalAccounts.length ) {
            const list = user.additionalAccounts.map( a => (
                {
                    ...a,
                    checked: ( user.viewing && user.viewing.find( f => f === a.aid ) !== undefined )
                }
            ) );
            setFullList( list );
        }
    }, [ user.additionalAccounts, user.viewing ] );

    useEffect( () => {
        console.log( 'uv: ', user.viewing );
    }, [ user.viewing ] );

    useEffect( () => {
        if ( !search || search === '' ) {
            setCurrList( fullList );
        } else {
            const list = fullList.filter( f => {
                if ( f.label && f.label.toLowerCase().includes( search.toLowerCase() ) ) {
                    return true;
                }
                return false;
            } );

            setCurrList( list );
        }
    }, [ search, fullList ] );

    useEffect( () => {
        const checked = fullList.filter( f => f.checked );
        setNewView( checked.map( m => m.aid ) );
    }, [ fullList ] );

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '450px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>View Data For...</Col>
                </Row>
                {
                    ( fullList.length > 10 ) ? (
                        <Row className='py-3'>
                            <Col><Form.Control className='tf-modal-text-input' type="text" placeholder="Search your accounts..." value={search} onChange={filterGroup} /></Col>
                        </Row>
                    ) : (
                        null
                    )
                }
                <Row className='py-2 align-items-center'>
                    <Col xs='auto' className='p-0'><Button style={{ fontSize: '12px' }} size='sm' variant='link' onClick={ () => selectAll() }>Select All</Button></Col>
                    <Col xs='auto' className='p-0'>|</Col>
                    <Col xs='auto' className='p-0'><Button style={{ fontSize: '12px' }} size='sm' variant='link' onClick={ () => deselectAll() }>Remove All</Button></Col>
                </Row>
                <Row>
                    <Col>
                        <ListGroup variant='flush' className='overflow-scroll' style={ { maxHeight: '65vh' }}>
                        {
                            currList.map( ( a, idx ) => ( 
                                <ListGroup.Item key={idx}>
                                    <Row className='tf-modal-list-item align-items-center'>
                                        <Col xs='auto'><Form.Check type='checkbox' className='tf-form-checkbox-field' aria-label={a.aid} checked={a.checked} onChange={ () => prepSwitch( a.aid ) } /></Col>
                                        <Col>{a.name}</Col>
                                    </Row>
                                </ListGroup.Item> 
                            ) )
                        }
                        </ListGroup>
                    </Col>
                </Row>
                <Row className='py-2'>
                    <Col>
                        <Button size='sm' variant='outline-primary' onClick={ () => applySwitch() } disabled={!newView.length}>Apply</Button>
                    </Col>
                </Row>
            </Box>
            <ToastContainer autoClose={3000} />
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    user: state.user
} );
  
const mapDispatch = ( dispatch ) => ( {
    setViewing: dispatch.user.setViewing
} );
  
export default connect( mapProps, mapDispatch )( SwitchAccounts );